import React, { PropTypes } from 'react';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';

export default class ToggleButtons extends React.Component {
  static propTypes = {
    buttons: PropTypes.arrayOf(React.PropTypes.shape({
      icon: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired
    })),
    preventFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  getColor(checked) {
    let { checkbox, toolbar } = this.context.muiTheme;

    return checked ? checkbox.checkedColor : toolbar.iconColor;
  }

  _isChecked(button) {
    let { multiple, value } = this.props;
    return multiple ? value.has(button.value) : button.value === value;
  }

  onClick(event, value) {
    let { preventFocus, onChange } = this.props;
    if (preventFocus) {
      event.preventDefault();
    }
    onChange(value);
  }

  onMouseDown(event, value) {
    let { disabled } = this.props;
    if (!disabled) {
      this.onClick(event, value);
    }
    return false;
  }

  render() {
    let { buttons, disabled } = this.props;

    return (
      <span>
      {buttons.map((button, index) => (
        <IconButton key={index}
                    disabled={disabled}
                    tabIndex={-1}
                    onMouseDown={(event) => this.onMouseDown(event, button.value)}>
          <FontIcon className="material-icons"
                    color={this.getColor(this._isChecked(button))}
          >{button.icon}</FontIcon>
        </IconButton>
      ))}
      </span>
    );
  }
}

ToggleButtons.defaultProps = {
  preventFocus: false,
  multiple: false
};



// WEBPACK FOOTER //
// ./src/components/form/ToggleButtons.jsx